module.exports = __webpack_public_path__ + "img/BlendBuff-Unhappy.c2b61707.png";